import { useContext, useMemo } from 'react'
import LegalAgreementsListingTabs from './LegalAgreementsListingTabs'
import LegalListItem from './LegalListItem'
import { MentorLegalNoAgreements, MentorLegalPageContainer } from './styledComponents'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { useNavigate } from 'react-router'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'

export function LegalPoliciesListingComponent({
  header,
  tabs = true,
  customOnClick,
  showOnlyNotAccepted = false,
  allLegalPolicies = [],
  mentorProfileData,
}) {
  const Header = useMemo(() => {
    return header ? header : null
  }, [header])

  const { profileData } = useContext(ProfileContext)
  const navigate = useNavigate()

  let legalPoliciesList = [...(allLegalPolicies || [])]
  legalPoliciesList = [
    ...(getAllRolesInBoolean().isDoctor
      ? [
          {
            title: 'AUMHUM Terms',
            agreementId: 'aumhum-terms',
            signed: true,
            acceptedTime: profileData?.createdTime,
            applicableSince: '2025-01-01 00:00:00',
            onClick: () => {
              navigate('/terms')
            },
          },
        ]
      : []),
    ...legalPoliciesList,
  ]

  return (
    <>
      {Header && Header}
      <MentorLegalPageContainer>
        {tabs && <LegalAgreementsListingTabs />}
        {legalPoliciesList?.length !== 0 ? (
          legalPoliciesList
            ?.sort((agreement1, agreement2) => {
              if (agreement1?.signed === agreement2?.signed) return 0
              else {
                return agreement1?.signed ? 1 : -1
              }
            })
            ?.filter((agreement) => {
              if (showOnlyNotAccepted) {
                return !agreement?.signed
              } else {
                return true
              }
            })
            ?.map((policy, idx) => (
              <LegalListItem
                mentorProfileData={mentorProfileData}
                onClick={policy?.onClick ? policy?.onClick : customOnClick}
                key={`${policy?.id} - ${idx}`}
                item={policy}
              />
            ))
        ) : (
          <MentorLegalNoAgreements>No Agreements Available</MentorLegalNoAgreements>
        )}
      </MentorLegalPageContainer>
    </>
  )
}
